module.exports = __webpack_public_path__ + "img/SWITZER DYNAMICS.f1cd7e8.jpg";